import React, { Fragment, useContext, lazy, Suspense, useEffect, useState } from "react";
import ELEMENTS from "./ELEMENTS";
import Error from "../../../src/Error";

import Zoom from '@material-ui/core/Zoom';
import Collapse from '@material-ui/core/Collapse';
import Grow from '@material-ui/core/Grow';
import { useTranslation } from "react-i18next";

// import TEXTBOX from './TEXTBOX'
// import SECTION from './SECTION'
// import ROW from './ROW'
// import COLUMN from './COLUMN'
// import RADIOBOX from './Radio/Radio'
// import COMBOBOX from './ComboBox/ComboBox'
// import CHECKBOX from './CHECKBOX'
// import DATEPICKER from './Datepicker/DATEPICKER'
// import FORM from './FORM'
// import EMAIL from './EMAIL'
// import PHONENUMBER from './PHONENUMBER'
// import BUTTON from './BUTTON'
// import TEXTAREA from './TEXTAREA'
// import PASSWORD from './PASSWORD'
// import LISTBOX from './LISTBOX'
// import TOGGLE from './TOGGLE'
// import TAB from "./Tab/TAB";
// import MULTISELECT from './MultiSelect/MultiSelect'
// import TABLE from './TABLE'
// import LISTVIEW from './LISTVIEW'
// import ADVANCELISTVIEW from './ADVANCELISTVIEW'
// import LABEL from './LABEL'
// import LINK from './LINK'
// import PARAGRAPH from './PARAGRAPH'
// import PICKLIST from './PICKLIST';
// import IFRAME from './../AdvanceFormControls/IFRAME';
// import IMAGE from './Image/Image';
// import RICHTEXTEDITOR from "./RICHTEXTEDITOR";
// import SLIDER from "./../AdvanceFormControls/SLIDER";
// import DocList from "./DocList/DocList";
// import IMAGECAROUSEL from "./IMAGECAROUSEL";
// import TILE from "./../AdvanceFormControls/Tile";
// import Wizard_H from "./Wizard_H/Wizard_H";
// import Wizard_V from "./Wizard_V/Wizard_V";
// import SideNavigation from "./SideNavigation/SideNavigation";
// import Report from "./Report/Report";
// import Captcha from './Captcha';

import {useDispatch,addContexts,useSelector} from "../../Redux"

// import TEXTBOX from "./TEXTBOX";
// import SECTION from "./SECTION";
import RowWrapper from "./ROW/RowWrapper.jsx";
import ColumnWrapper from "./COLUMN/ColumnWrapper.jsx";
import { GetStateFromData } from "../../components/CustomHooks/CustomHooks.js";
import { updateFormStateContextWithoutRender } from "../../Redux/Actions/FormStateActions.js";
// import RADIOBOX from "./Radio/Radio";
// import COMBOBOX from "./ComboBox/ComboBox";
// import CHECKBOX from "./CHECKBOX";
// import DATEPICKER from "./Datepicker/DATEPICKER";
// import FORM from "./FORM";
// import EMAIL from "./EMAIL";
// import PHONENUMBER from "./PHONENUMBER";
// import BUTTON from "./BUTTON";
// import TEXTAREA from "./TEXTAREA";
// import PASSWORD from "./PASSWORD";
// // import LISTBOX from "./LISTBOX";
// import TOGGLE from "./TOGGLE";
// import TAB from "./Tab/TAB";
// import MULTISELECT from "./MultiSelect/MultiSelect";
// import TABLE from "./TABLE";
// import LISTVIEW from "./LISTVIEW";
// import ADVANCELISTVIEW from "./ADVANCELISTVIEW";
// import LABEL from "./LABEL";
// import LINK from "./LINK";
// import PARAGRAPH from "./PARAGRAPH";
// import PICKLIST from "./PICKLIST";
// import IFRAME from "./../AdvanceFormControls/IFRAME";
// import IMAGE from "./Image/Image";
// import RICHTEXTEDITOR from "./RICHTEXTEDITOR";
// import SLIDER from "./../AdvanceFormControls/SLIDER";
// import DocList from "./DocList/DocList";
// import IMAGECAROUSEL from "./IMAGECAROUSEL";
// import TILE from "./../AdvanceFormControls/Tile";
// import Wizard_H from "./Wizard_H/Wizard_H";
// import Wizard_V from "./Wizard_V/Wizard_V";
// import SideNavigation from "./SideNavigation/SideNavigation";
// import Report from "./Report/Report";
// // import CUSTOMCONTROL from "./CustomControl/CUSTOMCONTROL";
// import Captcha from "./Captcha";
// import Menu from "./Menu";


const TEXTBOX = lazy(() => import("./TEXTBOX"));
const SECTION = lazy(() => import("./SECTION/SectionWrapper.jsx"));
// const ROW = lazy(() => import("./ROW"));
// const COLUMN = lazy(() => import("./COLUMN"));
const RADIOBOX = lazy(() => import("./Radio/Radio"));
const COMBOBOX = lazy(() => import("./ComboBox/ComboBox"));
const CHECKBOX = lazy(() => import("./CHECKBOX"));
const DATEPICKER = lazy(() => import("./Datepicker/DATEPICKER"));
const FORM = lazy(() => import("./FORM"));
const EMAIL = lazy(() => import("./EMAIL"));
const PHONENUMBER = lazy(() => import("./PHONENUMBER"));
const BUTTON = lazy(() => import("./BUTTON"));
const TEXTAREA = lazy(() => import("./TEXTAREA"));
const PASSWORD = lazy(() => import("./PASSWORD"));
// const LISTBOX = lazy(() => import("./LISTBOX"));
const TOGGLE = lazy(() => import("./TOGGLE"));
const TAB = lazy(() => import("./Tab/TabWrapper"));
const MULTISELECT = lazy(() => import("./MultiSelect/MultiSelect"));
const TABLE = lazy(() => import("./TABLE"));
const LISTVIEW = lazy(() => import("./LISTVIEW"));
const ADVANCELISTVIEW = lazy(() => import("./ADVANCELISTVIEW"));
const LABEL = lazy(() => import("./LABEL"));
const LINK = lazy(() => import("./LINK"));
const PARAGRAPH = lazy(() => import("./PARAGRAPH"));
const PICKLIST = lazy(() => import("./PICKLIST"));
const IFRAME = lazy(() => import("./../AdvanceFormControls/IFRAME"));
const IMAGE = lazy(() => import("./Image/Image"));
const RICHTEXTEDITOR = lazy(() => import("./RICHTEXTEDITOR"));
const SLIDER = lazy(() => import("./../AdvanceFormControls/SLIDER"));
const DocList = lazy(() => import("./DocList/DocumentIntegration.js"));
const IMAGECAROUSEL = lazy(() => import("./IMAGECAROUSEL"));
const TILE = lazy(() => import("./../AdvanceFormControls/Tile"));
const WizardWrapper = lazy(() => import("./WizardWrapper.jsx"));
const Report = lazy(() => import("./Report/Report"));
const CUSTOMCONTROL = lazy(() => import("./CustomControl/CUSTOMCONTROL"));
const Captcha = lazy(() => import("./Captcha"));
const Menu = lazy(() => import("./Menu"));

function isArray(obj) {
  return obj !== undefined && obj !== null && obj.constructor == Array;
}
function isObject(obj) {
  return obj !== undefined && obj !== null && obj.constructor == Object;
}
const elementMap = {
  frame: SECTION,
  section: SECTION,
  headerframe: SECTION,
  row: RowWrapper,
  textbox: TEXTBOX,
  column: ColumnWrapper,
  radio: RADIOBOX,
  combo: COMBOBOX,
  checkbox: CHECKBOX,
  datepick: DATEPICKER,
  email: EMAIL,
  form: FORM,
  phonenumber: PHONENUMBER,
  button: BUTTON,
  textarea: TEXTAREA,
  password: PASSWORD,
  listbox: MULTISELECT,
  toggle: TOGGLE,
  tab: TAB,
  multiSelect: MULTISELECT,
  table: TABLE,
  listview: LISTVIEW,
  advancelistview: ADVANCELISTVIEW,
  label: LABEL,
  link: LINK,
  paragraph: PARAGRAPH,
  iframe: IFRAME,
  picklist: PICKLIST,
  image: IMAGE,
  doclist: DocList,
  richtexteditor: RICHTEXTEDITOR,
  slider: SLIDER,
  imagecarousel: IMAGECAROUSEL,
  tile: TILE,
  wizard_h: WizardWrapper,
  wizard_v: WizardWrapper,
  sidenavigation: WizardWrapper,
  report: Report,
  captcha : Captcha,
  Menu:Menu,
  CustomControl : CUSTOMCONTROL
  // multiSelect:MULTISELECT
};

const ELEMENT = (props) => {
  const data = props.data;
  const device = props.device;
  const style = props.data && props.data !== null ? props.data.style : {};
  const isSubformInPage = props?.isSubformInPage || false;
  const dispatch = useDispatch();

  let haveData;
  let elem_type;
  let ELEM;
  let children;
  if (data && !Object.keys(data).length) {
    haveData = false;
  } else {
    if (data && 
      data.elem_type && 
      data.elem_type === "listview"
       && data.style && data.style["isAdvancedListview"] === "true") {
      elem_type = "advancelistview";
    } 
    else if(data && data.elem_type && data.elem_type === "advancelistView"){
      // elem_type: "advancelistView"
      elem_type = "advancelistview";
    }
    else if(data?.elem_type==="CustomControl" && data?.controlName!=="captcha" && data?.controlName!=="doclist" && data?.controlName!=="tile" && data?.controlName!=="slider" && data?.controlName!=="toggle"){
      elem_type = data.elem_type;
    }
    else if(data?.elem_type==="CustomControl" && data?.controlName){
      elem_type = data.controlName;
    }
    else {
      elem_type = data?.elem_type;
    }
    if(data?.elem_type == "textbox" && data?.style && data?.style?.isPassword == true)
      ELEM = elementMap['password'];  
    else
      ELEM = elementMap[elem_type];

    if (elem_type === "row") {
      ELEM = RowWrapper;
    }
    children = data?.children;
    if (children) {
      if (isArray(children)) {
      }
    } else {
    }
  }

  // const {setDragging,handleReorderStart,handleReorderDrop,selected,setSelected,clickFunc}=useContext(AppContext);
  // var setDragging;
  // var handleReorderStart;
  // var handleReorderDrop;
  // var selected;
  // var setSelected;
  // var clickFunc;
  // var setSelectedControl;
  // var AppContextVar = useContext(AppContext);
  // if (AppContextVar !== undefined) {
  //   setDragging = AppContextVar.setDragging;
  //   handleReorderStart = AppContextVar.handleReorderStart;
  //   handleReorderDrop = AppContextVar.handleReorderDrop;
  //   selected = AppContextVar.selected;
  //   setSelected = AppContextVar.setSelected;
  //   clickFunc = AppContextVar.clickFunc;
  //   setSelectedControl = AppContextVar.setSelectedControl;
  // }

  const contexts = GetStateFromData(props.containerId);
  const {t}=useTranslation();
  const {setDragging ,handleReorderStart ,handleReorderDrop ,selected ,setSelected ,updateJson ,setSelectedControl ,testClick, applyChanges }=contexts.contexts;
  const containerId=props.containerId;
  // const handleReorderStart=useContext(DragContext2);
  // const handleReorderDrop=useContext(DropContext2);
  // const selected=useContext(SelectedContext);
  // const setSelected=useContext(SetSelectedContext);
  // const click_context=useContext(ClickContext);

  // function handleSelected(e,idd,passedStatus){
  //     e.stopPropagation();

  //     if(selected.id===""){
  //         setSelected((prev)=>{
  //             return{
  //                 ...prev, id:idd, tempStatus:passedStatus
  //             }
  //         });
  //     } else if(selected.id!=="" && selected.tempStatus==="y" && idd===""){
  //         setSelected((prev)=>{
  //             return{
  //                 ...prev, id:"", tempStatus:""
  //             }
  //         });
  //     } else if(selected.id!=="" && selected.tempStatus==="y" && idd!==""){
  //         setSelected((prev)=>{
  //             return{
  //                 ...prev, id:idd, tempStatus:passedStatus
  //             }
  //         });

  //     } else if(selected.id!=="" && selected.tempStatus==="n" && passedStatus==="n"  ){
  //         setSelected((prev)=>{
  //             return{
  //                 ...prev, id:"", tempStatus:""
  //             }
  //         });
  //         clickFunc(e)
  //     }
  // }
  
  const handleSelected = React.useCallback( 
    (e, idd, passedStatus) => 
    {
    // setSelectedControl({});
    e.stopPropagation();
    // e.preventDefault();
    if (!props.previewmode) {
      // if(selected.id===""){
      //     setSelected((prev)=>{
      //         return{
      //             ...prev, id:idd, tempStatus:passedStatus
      //         }
      //     });
      // } else if(selected.id===idd){
      //     setSelected((prev)=>{
      //         return{
      //             ...prev, id:"", tempStatus:""
      //         }
      //     });
      // } else if(selected.id!=="" && selected.tempStatus==="y" && idd===""){
      //     setSelected((prev)=>{
      //         return{
      //             ...prev, id:"", tempStatus:""
      //         }
      //     });
      // } else if(selected.id!=="" && selected.tempStatus==="y" && idd!==""){
      //     setSelected((prev)=>{
      //         return{
      //             ...prev, id:idd, tempStatus:passedStatus
      //         }
      //     });

      // } else if(selected.id!=="" && selected.tempStatus==="n" && passedStatus==="n"  ){
      //     setSelected((prev)=>{
      //         return{
      //             ...prev, id:idd, tempStatus:passedStatus
      //         }
      //     });
      // }
      testClick(e, data, props);
    }
  },[]);

  function emptyFunction() {}

  useEffect(() => {
    if(!props?.previewmode) {
      dispatch(updateFormStateContextWithoutRender({name: "handleSelected", value: handleSelected, key: containerId}))
      // delete window.callOnlyOnce
    }
  }, [])

  // dispatch(updateFormStateContextWithoutRender({name: "handleSelected", value: handleSelected, key: containerId}))

  function emptyFunction(){

  }
  
  useEffect(()=>{
    if (style && style.FixSectionToTop && style.FixSectionToTop === "true") {
        let elindex;
        props?.children?.map((child, index)=>{if (child.id === props?.data?.id){elindex = index}})
        let removedEl = props?.children?.splice(elindex, 1)
        props?.children?.unshift(removedEl[0])
    }
  }, [style && style.FixSectionToTop])

  return (
    <>
      {/* <Error> */}
      <Suspense fallback={<div className="suspenseLoader"> {""} </div>}>
        {ELEM !== undefined ? (
          <ELEM
            {...props}
            isSubformInPage={isSubformInPage}
            tabsheetId={props?.tabsheetId}
            stepName={props?.stepName}
            key={data.id}
            isSubForm={props?.isSubForm || false}
            buttonId={props.buttonId}
            id={data.id}
            row_id={props?.row_id}
            data={data}
            sectionStyle={props?.sectionStyle}
            styleData={props.styleData}
            parentframeId={props.parentframeId}  
            stepIndex = {props?.stepIndex}
            previewmode={props.previewmode}
            containerId={containerId}
            isParentOfTab={props.isParentOfTab}  
            sheetName={props.sheetName}   
            wizardStepIndex = {props?.wizardStepIndex}    
            wizardSubStepIndex = {props?.wizardSubStepIndex}   
            applyChanges={!props?.previewmode ? (obj,saveOldState)=>applyChanges(obj, saveOldState) : emptyFunction}
            wizardStepName={props?.wizardStepName} wizardSubStepName = {props?.wizardSubStepName}
            // onDrop={(event)=>props.drop_prop(event)}
            // onDragOver={(event)=>props.allowdrop_prop(event)}
            frameindex={props.data.frameIndex || props.frameindex}
            drop_prop={props.drop_prop}
            allowdrop_prop={props.allowdrop_prop}
            setDragging={!props?.previewmode ? setDragging : emptyFunction}
            handleReorderStart={!props?.previewmode ? handleReorderStart : emptyFunction}
            handleReorderDrop={!props?.previewmode ? handleReorderDrop : emptyFunction}
            handleDragLeave={!props?.previewmode ? props?.handleDragLeave : emptyFunction}
            subStepIndex={props?.subStepIndex}
                                subStepName = {props?.subStepName}
            // selected={selected}
            setSelected={!props?.previewmode ? setSelected : emptyFunction}
            handleSelected={!props?.previewmode ? handleSelected : emptyFunction}
            device={props.device}
            style={style}
            showDataAdditionSection={props.showDataAdditionSection}
            //setShowDataAdditionSection={(arg)=>props.setShowDataAdditionSection(arg)}
            hasParentOfTab={props.hasParentOfTab}
            tabParentId={props.tabParentId}
            sheetid={props.sheetId}
            ReadOnlyStyle={props.ReadOnlyStyle}
            elementIndex={props.elementIndex || props.elementindex}
            sheetIndex={props.sheetIndex}
            sheetElementIndex={props.sheetElementIndex}
            openCanvasForSubform={props.openCanvasForSubform}
          >
            {children
              ? children && (
                  <ELEMENTS
                    row_id={props?.row_id}
                    tabsheetId={props?.tabsheetId}
                    isSubformInPage={isSubformInPage}
                    previewmode={props.previewmode}
                    parentframeId={props.parentframeId}  
                    stepName={props?.stepName}
                    isSubForm={props?.isSubForm || false}
                    buttonId={props.buttonId}
                    containerId={containerId}
                    device={props.device}
                    data={children}
                    sectionStyle={props?.sectionStyle}
                    handleSelected={!props?.previewmode ? handleSelected : emptyFunction}
                    stepIndex = {props?.stepIndex}
                    setSelected={!props?.previewmode ? setSelected : emptyFunction}
                    setDragging={!props?.previewmode ? setDragging : emptyFunction}
                    handleReorderStart={!props?.previewmode ? handleReorderStart : emptyFunction}
                    handleReorderDrop={!props?.previewmode ? handleReorderDrop : emptyFunction}
                    handleDragLeave={!props?.previewmode ? props?.handleDragLeave : emptyFunction}
                    subStepIndex={props?.subStepIndex}
                                subStepName = {props?.subStepName}
                    showDataAdditionSection={props.showDataAdditionSection}
                    setShowDataAdditionSection={(arg) =>
                      props.setShowDataAdditionSection(arg)
                    }
                    openCanvasForSubform={props.openCanvasForSubform}
                    wizardStepName={props?.wizardStepName} wizardSubStepName = {props?.wizardSubStepName}
                    frameindex={props.data.frameIndex}
                    wizardStepIndex = {props?.wizardStepIndex}    
                    wizardSubStepIndex = {props?.wizardSubStepIndex}   
                    elementIndex={props.elementIndex || props.elementindex}
                    sheetIndex={props.sheetIndex}
                    sheetElementIndex={props.sheetElementIndex}
                    sheetName={props.sheetName}
                    ReadOnlyStyle={props.ReadOnlyStyle}
                  />
                )
              : null}
          </ELEM>
        ) : null}
      </Suspense>
      {/* </Error> */}
    </>
  );
};

export default ELEMENT
